<div
  stchPopover
  [stchPopoverArrow]="true"
  [stchPopoverContent]="popoverTemplate"
  [stchPopoverInnerShadow]="true"
  stchPopoverPlacement="right"
  [stchPopoverDisabled]="!minimized"
  stchPopoverTrigger="click"
>
  <app-sidebar-item
    [title]="title"
    icon="file-folder"
    class="rounded hover:bg-hover"
    [depth]="depth ?? 0"
    [expandable]="true"
    [expanded]="expanded | lsValue: application : team?.id"
    [minimized]="minimized"
    [active]="currentTeamId === team?.id && sidebarFilter === 'all_folders'"
    (onExpand)="expanded.set($event, application, team?.id)"
    [actions]="[
      {
        icon: 'sapphire-plus',
        template: folderQuickFormTemplate,
        until: quickFormPopoverClose,
        appearance: 'dialog',
      },
    ]"
    (appClick)="selectFilter.emit('all_folders')"
    appSidebarContextMenu="all_folders"
    [appSidebarContextMenuTenantId]="tenantId"
  >
    <app-context-menu-state-indicator appearance="sapphire" svgIcon="sapphire-ellipsis" appFoldersListContextMenu />
  </app-sidebar-item>
</div>

@if (!minimized) {
  <div class="collapseable-body" [@heightAnimation]="(expanded | lsValue: application : team?.id) ? 'show' : 'hide'">
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </div>
}

<ng-template #popoverTemplate>
  @if (minimized) {
    <div class="popover-body">
      <ng-container *ngTemplateOutlet="contentTemplate" />
    </div>
  }
</ng-template>

<ng-template #contentTemplate>
  <app-side-bar-folders-tree
    [filters]="filters"
    [team]="team"
    [tenantId]="tenantId"
    [itemCreateFormTemplate]="folderQuickFormTemplate"
  />
</ng-template>

<ng-template #folderQuickFormTemplate let-parentId="parentId">
  <div class="quick-form-container">
    <app-folder-quick-form
      [autofocus]="true"
      [folder]="folderDraft(parentId)"
      [parentId]="parentId"
      [inline]="true"
      [showMore]="true"
      [showCancel]="true"
      (save)="createFolder($event)"
      (close)="quickFormPopoverClose.next()"
      (more)="handleMore($event)"
    />
  </div>
</ng-template>
